import {
  BROSWER_ENV,
  DEFAULT_DOC_TITLE,
  EMPTY_TEXT,
  NEW_TENANTCODE,
  NO_ERROR_TOAST_API,
  NO_TOAST_API,
} from "../const"
import { getCookie } from "./cookie"
import Storage from "./storage"
let EmployeeTenantCode =
  Storage.getStorage("tenantCode") || getCookie("tenantCode") || ""

//检查当前数据是否为空
function checkCurrentData(data: any) {
  if (data === undefined || data === null || data === "") {
    return false
  }
  return true
}

const formatDisplayText = (data: any, isNum?: boolean) => {
  if (data) {
    //文本类型
    return data
  }
  return isNum ? 0 : EMPTY_TEXT
}

//检查当前数据是否为空，排除了-符号
function checkDataUnEmpty(data: any) {
  if (checkCurrentData(data) && data !== EMPTY_TEXT) {
    return true
  }
  return false
}

/**
 * 是否为非空数组
 * @param arr
 * @returns
 */
function isNotEmptyArray(arr: any) {
  if (!checkCurrentData(arr)) {
    return false
  }
  if (Array.isArray(arr) && arr.length > 0) {
    return true
  }
  return false
}

function timeConvert(time: any, options?: any) {
  const { detail = false, emptyBack = EMPTY_TEXT, minute: showMinute = false } =
    options || {}
  let timestamp = time
  if (!checkCurrentData(timestamp)) {
    return emptyBack
  }
  let date = null
  if (checkDataType(timestamp) !== "date") {
    timestamp = timestamp.length === 10 ? timestamp * 1000 : timestamp
    date = new Date(timestamp)
  } else {
    date = timestamp
  }
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  let m1 = m < 10 ? `0${m}` : m
  let d = date.getDate()
  let d1 = d < 10 ? `0${d}` : d
  let h = date.getHours()
  let h1 = h < 10 ? `0${h}` : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let minute1 = minute < 10 ? `0${minute}` : minute
  let second1 = second < 10 ? `0${second}` : second
  if (!detail) {
    return `${y}-${m1}-${d1}`
  }
  if (showMinute) {
    return `${y}-${m1}-${d1} ${h1}:${minute1}`
  }
  return `${y}-${m1}-${d1} ${h1}:${minute1}:${second1}`
}

function checkDataType(data: any) {
  if (checkCurrentData(data)) {
    const type = Object.prototype.toString.call(data)
    return type.substring(8, type.length - 1).toLowerCase()
  }
  return ""
}

function isNotEmptyObject(obj: any) {
  if (checkCurrentData(obj)) {
    if (checkDataType(obj) === "object") {
      const arr = Object.getOwnPropertyNames(obj)
      if (isNotEmptyArray(arr)) {
        return true
      }
    }
  }
  return false
}

function checkBackData(data: any, detail?: { isEmpty?: boolean | undefined }) {
  const { isEmpty = false } = detail || {}
  if (checkCurrentData(data)) {
    return data
  } else {
    return isEmpty ? "" : EMPTY_TEXT
  }
}
function toDecimal2(val: any) {
  let f = parseFloat(val)
  if (isNaN(f)) {
    return 0
  }
  f = Math.round(val * 100) / 100
  let s = f.toString()
  let rs = s.indexOf(".")
  if (rs < 0) {
    rs = s.length
    s += "."
  }
  while (s.length <= rs + 2) {
    s += "0"
  }
  return s || ""
}

function checkIsPC() {
  const userAgentInfo = navigator.userAgent
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ]
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}
declare const screen: any

function getWindowHeight() {
  return screen?.availHeight
}

const imgReg = /((https?|ftp|file):[^:<>"]*\/)([^:<>"]*)(\.((png!thumbnail)|(png)|(jpg)|(webp)))/gim

// 慧慧沟通记录 - 链接处理
const replaceUrl = (text: string) => {
  const reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/gi
  let url = text || ""
  url = url.replace(imgReg, function (a) {
    return `<img title="图片" alt="图片" src="${a}" />`
  })
  if (Array.isArray(url.match(reg))) {
    let arr = url.match(reg)
    // 拿一个不是图片链接的链接数组
    arr = (arr || [])
      .filter((item) => {
        if (/(\.((png!thumbnail)|(png)|(jpg)|(webp)))/g.test(item)) {
          return undefined
        } else {
          return item
        }
      })
      .map((item) => item)
    if (arr.length) {
      arr.forEach((item) => {
        if (!imgReg.test(item)) {
          url = url.replace(
            item,
            `<a href="${item}" target="_blank" rel="noopener noreferrer">${item}</a>`,
          )
        }
      })
    }
  }
  return url
}

/**
 * @str 对慧慧返回的表情格式做处理（先这么写满足需求，后期优化）
 */
const handleFace = (str: string) => {
  const url = "//img.huizecdn.com/com/face/0"
  return str
    .replace(/\[调皮]/g, `<img title="调皮" alt="调皮" src="${url}01.gif"/>`)
    .replace(/\[偷笑]/g, `<img title="偷笑" alt="偷笑" src="${url}02.gif"/>`)
    .replace(/\[坏笑]/g, `<img title="坏笑" alt="坏笑" src="${url}03.gif"/>`)
    .replace(/\[亲亲]/g, `<img title="亲亲" alt="亲亲" src="${url}04.gif"/>`)
    .replace(/\[口水]/g, `<img title="口水" alt="口水" src="${url}05.gif"/>`)
    .replace(/\[狂笑]/g, `<img title="狂笑" alt="狂笑" src="${url}06.gif"/>`)
    .replace(/\[可爱]/g, `<img title="可爱" alt="可爱" src="${url}07.gif"/>`)
    .replace(/\[可怜]/g, `<img title="可怜" alt="可怜" src="${url}08.gif"/>`)
    .replace(/\[流泪]/g, `<img title="流泪" alt="流泪" src="${url}09.gif"/>`)
    .replace(/\[委屈]/g, `<img title="委屈" alt="委屈" src="${url}10.gif"/>`)
    .replace(/\[纠结]/g, `<img title="纠结" alt="纠结" src="${url}11.gif"/>`)
    .replace(/\[害羞]/g, `<img title="害羞" alt="害羞" src="${url}12.gif"/>`)
    .replace(/\[流汗]/g, `<img title="流汗" alt="流汗" src="${url}13.gif"/>`)
    .replace(/\[抓狂]/g, `<img title="抓狂" alt="抓狂" src="${url}14.gif"/>`)
    .replace(/\[鄙视]/g, `<img title="鄙视" alt="鄙视" src="${url}15.gif"/>`)
    .replace(/\[呕吐]/g, `<img title="呕吐" alt="呕吐" src="${url}16.gif"/>`)
    .replace(/\[衰]/g, `<img title="衰" alt="衰" src="${url}17.gif"/>`)
    .replace(/\[疑问]/g, `<img title="疑问" alt="疑问" src="${url}18.gif"/>`)
    .replace(/\[睡着]/g, `<img title="睡着" alt="睡着" src="${url}19.gif"/>`)
    .replace(/\[再见]/g, `<img title="再见" alt="再见" src="${url}20.gif"/>`)
    .replace(/\[抽烟]/g, `<img title="抽烟" alt="抽烟" src="${url}21.gif"/>`)
    .replace(/\[咒骂]/g, `<img title="咒骂" alt="咒骂" src="${url}22.gif"/>`)
    .replace(/\[酷]/g, `<img title="酷" alt="酷" src="${url}23.gif"/>`)
    .replace(/\[鼓掌]/g, `<img title="鼓掌" alt="鼓掌" src="${url}24.gif"/>`)
    .replace(/\[嘘]/g, `<img title="嘘" alt="嘘" src="${url}25.gif"/>`)
    .replace(
      /\[挖鼻孔]/g,
      `<img title="挖鼻孔" alt="挖鼻孔" src="${url}26.gif"/>`,
    )
    .replace(/\[思考]/g, `<img title="思考" alt="思考" src="${url}27.gif"/>`)
    .replace(/\[傲慢]/g, `<img title="傲慢" alt="傲慢" src="${url}28.gif"/>`)
    .replace(/\[惊恐]/g, `<img title="惊恐" alt="惊恐" src="${url}29.gif"/>`)
    .replace(/\[晕]/g, `<img title="晕" alt="晕" src="${url}30.gif"/>`)
    .replace(/\[心动]/g, `<img title="心动" alt="心动" src="${url}31.gif"/>`)
    .replace(/\[心碎]/g, `<img title="心碎" alt="心碎" src="${url}32.gif"/>`)
    .replace(/\[赞]/g, `<img title="赞" alt="赞" src="${url}33.gif"/>`)
    .replace(/\[握手]/g, `<img title="握手" alt="握手" src="${url}34.gif"/>`)
    .replace(/\[弱]/g, `<img title="弱" alt="弱" src="${url}35.gif"/>`)
    .replace(/\[不要]/g, `<img title="不要" alt="不要" src="${url}36.gif"/>`)
    .replace(/\[耶]/g, `<img title="耶" alt="耶" src="${url}37.gif"/>`)
    .replace(/\[来]/g, `<img title="来" alt="来" src="${url}38.gif"/>`)
    .replace(/\[吃饭]/g, `<img title="吃饭" alt="吃饭" src="${url}39.gif"/>`)
    .replace(/\[咖啡]/g, `<img title="咖啡" alt="咖啡" src="${url}40.gif"/>`)
}

const checkNoToastUrl = (url: string) => {
  for (let i = 0; i < NO_TOAST_API.length; i++) {
    const item = NO_TOAST_API[i]
    const urlStr = url.substring(0, url.lastIndexOf("/"))
    if (url === item || urlStr === item) {
      return false
    }
  }
  return true
}

const checkNoErrorToastUrl = (url: string) => {
  for (let i = 0; i < NO_ERROR_TOAST_API.length; i++) {
    const item = NO_ERROR_TOAST_API[i]
    const urlStr = url.substring(0, url.lastIndexOf("/"))
    if (url === item || urlStr === item) {
      return false
    }
  }
  return true
}

const downloadFileBlob = (data: any, name?: string) => {
  if (data) {
    const blob = data
    const reader = new FileReader()
    reader.readAsDataURL(blob) // 转换为base64，可以直接放入a表情href
    reader.onload = function (e: any) {
      let a: any = document.createElement("a")
      const fileName = `${name || new Date().getTime()}.zip`

      a.download = fileName
      a.href = e.target.result
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}

/**
 * @Description 判断是在 企业微信/微信/浏览器 哪个平台打开的
 * @author hz21087108
 * @date 2021-08-17
 * @returns {any}
 */
const getBrowserEnv = () => {
  const agent: string = navigator.userAgent.toLowerCase()
  if (agent.includes("wxwork")) {
    return BROSWER_ENV.WXWORK
  }

  if (agent.includes("micromessenger")) {
    return BROSWER_ENV.WEIXIN
  }

  return BROSWER_ENV.BROSWER
}

/**
 * @Description 防抖函数
 * @author hz21087108
 * @date 2021-08-11
 * @param {any} callback
 * @returns {Function} 新的回调函数
 * @example
 * <button onClick={debounce(() => alert(1), 1000).bind(this)}>确定</botton>
 */
// eslint-disable-next-line
const debounce = (callback: (args: any) => void, time: number, args?: any) => {
  let timer: any
  return () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(() => callback.call(this, args), time)
  }
}

const updateDocTitle = (title: string) => {
  document.title = title || DEFAULT_DOC_TITLE
}

/**
 * @Description 判断当前租户是否是新租户(100001)
 * @author hz20126003
 * @date 2021-08-23
 * @returns {boolean}
 */
const checkIsNewTenant = () => {
  if (!EmployeeTenantCode) {
    EmployeeTenantCode =
      Storage.getStorage("tenantCode") || getCookie("tenantCode") || ""
  }
  return EmployeeTenantCode === NEW_TENANTCODE
}

function isQywxPhone() {
  //判断当前入口是PC端还是APP端
  return checkApp() && is_weixin()
}
//区分手机和PC端
function checkApp() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  ) == null
    ? false
    : true
}

function isQywxPc() {
  return !checkApp() && is_weixin()
}

function is_weixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
}

/**
 *
 * 修改弹框颜色为 #1E77FF
 */
function onVisibleChange() {
  let styleElement: HTMLStyleElement | null = null
  return (isVisible: boolean) => {
    if (isVisible) {
      styleElement = document.createElement("style")
      const css = document.createTextNode(
        `.am-picker-popup-header-left {color: #1E77FF !important;} 
        .am-picker-popup-header-right {color: #1E77FF !important;}`,
      )
      styleElement.appendChild(css)
      document.head.appendChild(styleElement)
    } else {
      styleElement?.remove()
    }
  }
}

export type IsEqual<A, B> = [A, B] extends [B, A] ? true : false

const checkIsAndroid = () => {
  let u = navigator.userAgent
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1 //g
  let isIOS = Boolean(u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) //ios终端
  if (isAndroid) {
    return true
  } else if (isIOS) {
    return false
  }
}
const dealWithIgnoreCase = (pathname: string, pathArr: Array<string>) => {
  if (!checkCurrentData(pathname) || !isNotEmptyArray(pathArr)) {
    return false
  }
  return pathArr.some(
    (path: string) => pathname.toLocaleLowerCase() === path.toLocaleLowerCase(),
  )
}

const sendBeacon = (url: string, data: any) => {
  if (url) {
    navigator.sendBeacon(url, data)
  }
}

export {
  checkCurrentData,
  isNotEmptyArray,
  timeConvert,
  isNotEmptyObject,
  checkDataType,
  checkBackData,
  checkDataUnEmpty,
  formatDisplayText,
  toDecimal2,
  checkIsPC,
  getWindowHeight,
  replaceUrl,
  handleFace,
  checkNoToastUrl,
  downloadFileBlob,
  debounce,
  updateDocTitle,
  checkIsNewTenant,
  isQywxPc,
  isQywxPhone,
  getBrowserEnv,
  checkNoErrorToastUrl,
  onVisibleChange,
  checkApp,
  checkIsAndroid,
  dealWithIgnoreCase,
  sendBeacon,
}
